import { Tabs } from "tamagui";
import { color } from "@my/util";
import { jsx } from "react/jsx-runtime";
const TZATabs = {
  List: props => /* @__PURE__ */jsx(Tabs.List, {
    style: {
      backgroundColor: "rgb(246, 246, 246)",
      //borderBottomWidth: 2,
      //borderBottomStyle: 'solid',
      //borderBottomColor: color.tzaGreen,
      borderRadius: 4
    },
    ...props
  }),
  Tab: props => /* @__PURE__ */jsx(Tabs.Tab, {
    margin: 5,
    borderRadius: 10,
    activeStyle: {
      backgroundColor: "white",
      color: color.tzaGreen,
      boxShadow: "rgba(0, 0, 0, 0.085) 0px 2px 1px 0.5px"
    },
    flex: 1,
    ...props
  })
};
export { TZATabs };
//# sourceMappingURL=tabs.mjs.map
